/**
 * Variant Info Drawer
 * Handles opening/closing of the variant information drawer
 */
(function() {
    'use strict';

    function initVariantInfoDrawer() {
        const triggers = document.querySelectorAll('.variant-info-trigger');
        const sidebar = document.getElementById('variant-info-sidebar');
        const content = document.getElementById('variant-info-content');
        const title = document.getElementById('variant-info-title');
        const closeBtn = document.querySelector('[data-close-variant-info]');
        const overlay = document.querySelector('.background-overlay');

        if (!sidebar || triggers.length === 0) return;

        // Open drawer on trigger click
        triggers.forEach(trigger => {
            trigger.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                const type = this.dataset.infoType;
                const template = document.getElementById('variant-info-' + type);

                if (template) {
                    // Set content from template
                    content.innerHTML = template.innerHTML;

                    // Set title based on type
                    const titleMap = {
                        'formaat': 'Formaat',
                        'materiaal': 'Materiaal',
                        'lijsten': 'Lijsten'
                    };
                    title.textContent = titleMap[type] || 'Information';

                    // Open drawer
                    document.body.classList.add('variant-info-show');
                }
            });
        });

        // Close drawer on close button click
        if (closeBtn) {
            closeBtn.addEventListener('click', closeDrawer);
        }

        // Close drawer on overlay click
        if (overlay) {
            overlay.addEventListener('click', function(e) {
                if (document.body.classList.contains('variant-info-show')) {
                    // Only close if not clicking inside the sidebar
                    if (!e.target.closest('#variant-info-sidebar')) {
                        closeDrawer();
                    }
                }
            });
        }

        // Close drawer on escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && document.body.classList.contains('variant-info-show')) {
                closeDrawer();
            }
        });

        function closeDrawer() {
            document.body.classList.remove('variant-info-show');
        }
    }

    // Initialize on DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initVariantInfoDrawer);
    } else {
        initVariantInfoDrawer();
    }
})();
